// Breakpoints
export const breakpoint = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};

// Colors
export const color = {
  white: 'white',
  orange: '#ea4325',
  gray: {
    border: '#eaeaec',
    text: '#94979e',
    light: '#f6f6f6'
  },
  black: '#292f3d',
  blue: '#058ed9',
  green: '#27ae60',
  red: '#c70039',
  redBg: '#c700381a'
};

// Font Weight
export const fontWeight = {
  normal: 400,
  semibold: 590,
  bold: 700
};

// Font Size
export const fontSize = {
  xs: 13,
  sm: 15,
  smMd: 16,
  md: 17,
  lg: 20,
  xl: 24,
  xlXxl: 30,
  xxl: 46
};

// Line height
export const lineHeight = {
  sm: 20,
  md: 24,
  lg: 32
};
